import { render, staticRenderFns } from "./VatSetupForm.vue?vue&type=template&id=1c31d1aa&scoped=true&"
import script from "./VatSetupForm.vue?vue&type=script&lang=js&"
export * from "./VatSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31d1aa",
  null
  
)

export default component.exports